module.exports = __webpack_public_path__ + "static/v1.b-thumb-cdb609e007bc46745577ca85ac333309.jpg";